import React from "react";
import * as PropTypes from "prop-types";
import { Grid } from "@material-ui/core";

export const OoChartGridContainer = ({ children }) => (
  <Grid container
        spacing={3}
        direction="row"
        wrap="wrap"
        alignItems="stretch"
        justify="center"
  >
    {children}
  </Grid>
);
OoChartGridContainer.propTypes = {
  children: PropTypes.node.isRequired,
};


export const OoChartGridItem = ({ children }) => (
  <Grid item xs={12} sm={6} md={6}>
    {children}
  </Grid>
);
OoChartGridItem.propTypes = {
  children: PropTypes.node.isRequired,
};
